module.exports = __webpack_public_path__ + "media/images/about-trainer_hero-image@2x-8204665fa94257ba45374a4e8be793cd.jpg";